import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDPsPrizeRedeem implements ICommand
{

	public PrizeID : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.PrizeID = ba.readUint32();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint32(this.PrizeID);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDPsPrizeRedeem();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'PrizeID(D)='+this.PrizeID+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 55073;
	}

	public getCmdName() : string
	{
		return 'PsPrizeRedeem';
	}

}
